"use client";

/**
 * UIX ThemeContext - Globális Téma Állapot
 *
 * Biztosítja az aktív témát az összes UIX komponens számára.
 * A ThemeInjector fogyasztja, hogy CSS változókat injektáljon.
 */

import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { UixTheme } from "../style/theme.types";
import { defaultTheme } from "../style/themes";

interface ThemeContextValue {
    theme: UixTheme;
    setTheme: (theme: UixTheme) => void;
    themeId: string;
}

const ThemeContext = createContext<ThemeContextValue>({
    theme: defaultTheme,
    setTheme: () => { },
    themeId: "default",
});

export const ThemeProvider: React.FC<{
    children: ReactNode;
    initialTheme?: UixTheme;
}> = ({ children, initialTheme = defaultTheme }) => {
    const [theme, setThemeState] = useState<UixTheme>(initialTheme);

    const setTheme = useCallback((newTheme: UixTheme) => {
        setThemeState(newTheme);
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setTheme, themeId: theme.id }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useUixTheme = (): ThemeContextValue => {
    return useContext(ThemeContext);
};
